<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        style="max-width:36px !important"
        icon
        @click.stop=""
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Emergency Contacts"
      text="Create emergency contacts"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="name"
                v-validate="'required|max:80|nameAllowedFormat'"
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"  
                outlined
                :class="{
                  'required':!name
                }"
                @input="name = name.toUpperCase()"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="relationship"
                v-validate="'required'"
                :items="relationships"
                label="Relationship"
                :error-messages="errors.collect('relationship')"
                data-vv-name="relationship"    
                data-vv-as="relationship"     
                item-text="name"
                item-value="id"
                outlined
                :class="{
                  'required':!relationship
                }"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="contact_no"
                v-validate="'required'"
                :error-messages="errors.collect('contact_no')"
                data-vv-name="contact_no"                
                data-vv-as="contact no"                
                label="Contact No."
                outlined
                :class="{
                  'required':!contact_no
                }"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        name: null,
        relationships: [],
        relationship: null,
        contact_no: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.$validator.extend('nameAllowedFormat', {
          getMessage (field, args) {
            return "Invalid name format. Only alphabet and special character of @ ' * - / . allowed for name"     
          },
          validate (value, args) {
            const regex = /^[ A-Za-z'@./*-]*$/
            return regex.test(value)
          },
        })

        this.loading = true
     
        this.$api.hrisRelationships().list()
          .then(res => {
            this.relationships = res.data

            this.loading = false
          })
      },
    },
    methods: { 
      prepareFormData () {
        return {
          name: this.name,
          relationship_id: this.relationship,
          contact_no: this.contact_no,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.emergencyContacts().create(this.employeeUid, this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false       
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },

    },
  }
</script>

<style scoped>
.required >>> fieldset {
  border: 2px solid red;
}
</style>
